<div>
  <div *ngIf="!init" class="map-loader-overlay">
    <div style="margin-top: 200px; align-self: center">
      <mat-spinner
        style="margin: auto"
        color="primary"
        diameter="75"
      ></mat-spinner>
    </div>
  </div>
  <map-view
    [latitude]="INPRESS_COORDINATES.lat"
    [longitude]="INPRESS_COORDINATES.lng"
    [zoom]="14"
    [scrollwheel]="true"
    [fitBounds]="subProjects?.length > 0"
    [styles]="HIDE_POI_STYLE"
    [disableDefaultUI]="true"
    (mapClick)="mapClick()"
  >
    <map-marker
      [latitude]="INPRESS_COORDINATES.lat"
      [longitude]="INPRESS_COORDINATES.lng"
      [iconUrl]="'../../../../../../favicon.ico'"
    ></map-marker>
    <map-marker
      *ngFor="let group of subProjectGroups"
      [latitude]="group.lat"
      [longitude]="group.lng"
      [iconUrl]="{
        url: '../../../../../../assets/markers/' + group.markerColor
      }"
      [openInfoWindow]="true"
      [mapFitBounds]="init"
      (markerClick)="markerClick(infoWindow, group)"
    >
      <map-info-window #infoWindow>
        <admin-planning-marker-popup
          [subProjectGroup]="group"
          [placerOptions]="placerOptions"
          [groupSelected]="groupSelected"
          [showSubmitPlanContent]="showSubmitPlanContent"
          (updatePlanValues)="updatePlanValues($event)"
        ></admin-planning-marker-popup>
      </map-info-window>
    </map-marker>
  </map-view>
  <div *ngIf="!!totalDistance" class="distance-legend">
    Totale afstand: <b>{{ totalDistance }}</b>
  </div>
</div>
